/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyTokushohoTypename = "PharmacyTokushoho" as const;

/**
 *
 * @export
 * @interface PharmacyTokushoho
 */
export interface PharmacyTokushoho {
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  address?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  cancel?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  cost?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  deliveryTiming?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  payment?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  representative?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  sellingCost?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  serviceProvider?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  tel?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyTokushoho
   */
  readonly __typename?: string;
}

export function PharmacyTokushohoFromJSON(json: any): PharmacyTokushoho {
  return PharmacyTokushohoFromJSONTyped(json, false);
}

export function PharmacyTokushohoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyTokushoho {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyTokushohoTypename,

    address: !exists(json, "address") ? undefined : json["address"],
    cancel: !exists(json, "cancel") ? undefined : json["cancel"],
    cost: !exists(json, "cost") ? undefined : json["cost"],
    deliveryTiming: !exists(json, "delivery_timing") ? undefined : json["delivery_timing"],
    payment: !exists(json, "payment") ? undefined : json["payment"],
    postalCode: !exists(json, "postal_code") ? undefined : json["postal_code"],
    representative: !exists(json, "representative") ? undefined : json["representative"],
    sellingCost: !exists(json, "selling_cost") ? undefined : json["selling_cost"],
    serviceProvider: !exists(json, "service_provider") ? undefined : json["service_provider"],
    tel: !exists(json, "tel") ? undefined : json["tel"],
  };
}

export function PharmacyTokushohoToJSON(object?: PharmacyTokushoho | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    address: value.address,
    cancel: value.cancel,
    cost: value.cost,
    delivery_timing: value.deliveryTiming,
    payment: value.payment,
    postal_code: value.postalCode,
    representative: value.representative,
    selling_cost: value.sellingCost,
    service_provider: value.serviceProvider,
    tel: value.tel,
  };
}
